// extracted by mini-css-extract-plugin
module.exports = {"VerificationCodeInput":"VerificationCodeInput_VerificationCodeInput__rbwcE"};